import { DEFAULT_USER, INTEGRATION_DOCUMENT } from '~/consts/psf';
import type { StoreInformation } from '~/domain/PSF';
import type { GetStoreResponseDTO } from '~/dto/PSF';
import { storeInfoDTToSellerInfo } from '~/mappers/PSF';
import apiPSFAnon from '~/services/apiPSFAnon';

export async function getStoreInformationUseCase(
  storeCode: string
): Promise<StoreInformation | false> {
  try {
    const response = await apiPSFAnon.get<GetStoreResponseDTO>(
      `/client/api/filial/filiaisDisponiveis/${storeCode}`,
      {
        headers: {
          loginUsuario: DEFAULT_USER,
          cpfUsuario: INTEGRATION_DOCUMENT,
          functionality: 'filiaisDisponiveis',
          service: 'filial',
        },
      }
    );

    return storeInfoDTToSellerInfo(response.data);
  } catch (err) {
    return false;
  }
}
